import Vue from 'vue'
import EntityTitle from '@/entity/components/EntityTitle'
import ReportTable from "../components/ReportTable"


let vm = {
    components:{EntityTitle,ReportTable},
    data(){
        return{
            oaid:null,
            tableColumn:[
                {title:'i18n.researchreport.publish_date',field:"publish_date",width:150,sortType:"date",sortable:true},
                {title:'i18n.researchreport.title',field:"title",width:500},
                {title:'i18n.researchreport.instituion',field:"institution",width:150},
                {title:'i18n.researchreport.analyst',field:"researcher_name"},
                {title:'i18n.researchreport.key_words',field:"subject_words",width:300},
                {title:'i18n.researchreport.novelty',field:"innovation_rate",width:150,sortType:"number",sortable:true},
                {title:"i18n.researchreport.more", slots: {default: 'num_default'}},
            ],

        }
    },
    methods:{
        // 获取oaid
        async getOaid(){
            let self=this
            let id=this.$route.params.oaid
            if(escape(id).indexOf("%u")<0){
                this.oaid=this.$route.params.oaid
            }else{
                await entityOaid.oaid(id).then(result => {
                    self.oaid =result
                  })
            }
        },

    },
    mounted(){
        this.getOaid()
    }
}

Vue.component("recent-report", vm)
export default vm



// WEBPACK FOOTER //
// ./src/research_report/js/recent_report.js